const NOT_APPLY = 0;
const ON_APROBATION = 1;
const APPROVED = 2;
const REJECTED = 3;

export const ApprovalStateNames = {
  0: 'No aplica',
  1: 'En aprobación',
  2: 'Aprobado',
  3: 'Rechazado'
};

export default {
  NOT_APPLY,
  APPROVED,
  ON_APROBATION,
  REJECTED
};
